"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactHooks = require("@trycourier/react-hooks");

var _constants = require("../constants");

var useMessageOptions = function useMessageOptions(_ref) {
  var archiveTrackingId = _ref.archiveTrackingId,
      labels = _ref.labels,
      messageId = _ref.messageId,
      read = _ref.read,
      readTrackingId = _ref.readTrackingId,
      showArchived = _ref.showArchived,
      unreadTrackingId = _ref.unreadTrackingId;

  var _useInbox = (0, _reactHooks.useInbox)(),
      markMessageRead = _useInbox.markMessageRead,
      markMessageUnread = _useInbox.markMessageUnread,
      markMessageArchived = _useInbox.markMessageArchived;

  var messageOptions = [];

  if (!read && readTrackingId && messageId) {
    var _labels$markAsRead;

    messageOptions.push({
      label: (_labels$markAsRead = labels === null || labels === void 0 ? void 0 : labels.markAsRead) !== null && _labels$markAsRead !== void 0 ? _labels$markAsRead : _constants.MESSAGE_LABELS.MARK_AS_READ,
      onClick: function onClick() {
        markMessageRead(messageId, readTrackingId);
      }
    });
  }

  if (read && unreadTrackingId && messageId) {
    var _labels$markAsUnread;

    messageOptions.push({
      label: (_labels$markAsUnread = labels === null || labels === void 0 ? void 0 : labels.markAsUnread) !== null && _labels$markAsUnread !== void 0 ? _labels$markAsUnread : _constants.MESSAGE_LABELS.MARK_AS_UNREAD,
      onClick: function onClick() {
        markMessageUnread(messageId, unreadTrackingId);
      }
    });
  }

  if (showArchived && archiveTrackingId && messageId) {
    var _labels$archiveMessag;

    messageOptions.push({
      label: (_labels$archiveMessag = labels === null || labels === void 0 ? void 0 : labels.archiveMessage) !== null && _labels$archiveMessag !== void 0 ? _labels$archiveMessag : _constants.MESSAGE_LABELS.ARCHIVE_MESSAGE,
      onClick: function onClick() {
        markMessageArchived(messageId, archiveTrackingId);
      }
    });
  }

  return messageOptions;
};

var _default = useMessageOptions;
exports["default"] = _default;